import { render, staticRenderFns } from "./gobackMiniGame.vue?vue&type=template&id=880a850a&scoped=true"
import script from "./gobackMiniGame.vue?vue&type=script&lang=js"
export * from "./gobackMiniGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a850a",
  null
  
)

export default component.exports